import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';

@Component({
    name: 'domain-card',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class DomainCard extends Vue {

    // ------------------------------------------------------
    // Properties
    @Prop()
    private domainList: any;

    @Prop()
    private activeDomain: any;

    @Prop()
    private activeTopic: any;

    @Watch('activeDomain')
    private onScrollDomain(value: any) {
        const component = this;
        setTimeout(() => {
            const activeElement = component.$el.querySelector(`#domain-${value.domainSeq}`) as HTMLElement;
            activeElement.scrollIntoView({behavior: 'smooth', block: 'start'});
        }, 500);
    }

    // ------------------------------------------------------------------
    // Hooks

    // ----------------------------------------------------------------------------------
    // Actions
    private onSelectDomain(domain: any) {
        this.$emit('onSelectDomain', domain);

    }

    private onSelectTopic(topic: any) {
        this.$emit('onSelectTopic', topic);
    }

    private onSelectCompetency(competency: any) {
        this.$emit('onSelectCompetency', competency);
    }

}
